var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.virtualLog
    ? _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass:
                "active-virtuallog q-pt-sm q-px-md row justify-between"
            },
            [
              _c(
                "span",
                {
                  staticClass: "cursor-pointer text-primary",
                  on: {
                    click: function($event) {
                      return _vm.show()
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("virtual.title")) +
                      " " +
                      _vm._s(_vm.virtualLog.name)
                  ),
                  _c("q-icon", { attrs: { name: "expand_less" } })
                ],
                1
              ),
              _vm._v(" "),
              _vm.virtualLog.species
                ? _c("span", [_vm._v(_vm._s(_vm.virtualLog.species.name))])
                : _vm._e(),
              _vm._v(" "),
              _vm.virtualLog.logsMeta
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("label.itemCount")) +
                        ": " +
                        _vm._s(_vm.virtualLog.logsMeta.length)
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.virtualLog.logArea
                ? _c("span", [
                    _vm._v(_vm._s(_vm._f("area")(_vm.virtualLog.logArea)))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                [
                  _c("q-btn", {
                    attrs: { icon: "close", size: "sm", flat: "" },
                    on: { click: _vm.close }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "q-dialog",
            {
              staticClass: "virtual-log-builder bg-white",
              attrs: {
                value: _vm.editMode,
                "full-width": true,
                square: "",
                persistent: ""
              }
            },
            [
              _c(
                "q-card",
                [
                  _c(
                    "q-card-section",
                    { staticClass: "bg-primary q-px-md q-py-md q-mb-md" },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-10" }, [
                          _c(
                            "h5",
                            {
                              staticClass:
                                "text-white q-my-none cursor-pointer",
                              on: { click: _vm.hide }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("virtual.title")) +
                                  " " +
                                  _vm._s(_vm.virtualLog.name)
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-2" },
                          [
                            !_vm.editMode
                              ? _c("q-btn", {
                                  attrs: {
                                    icon: "close",
                                    color: "white",
                                    flat: ""
                                  },
                                  on: { click: _vm.close }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.editMode
                    ? [
                        _c(
                          "q-card-section",
                          [
                            !_vm.virtualLog.uid
                              ? [
                                  _c("log-property-form", {
                                    attrs: {
                                      log: _vm.virtualLog,
                                      errors: _vm.logPropertyFormErrors,
                                      "show-submit": true,
                                      loading: _vm.updating
                                    },
                                    on: {
                                      update: _vm.updateLogProps,
                                      close: _vm.close,
                                      "update-log": _vm.updateLog
                                    }
                                  })
                                ]
                              : [
                                  _vm.loading
                                    ? _c("q-spinner-cube", {
                                        attrs: { color: "primary", size: "2em" }
                                      })
                                    : !_vm.virtualLog.logs ||
                                      (_vm.virtualLog.logs &&
                                        !_vm.virtualLog.logs.length)
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "row q-col-gutter-md q-mt-lg justify-center"
                                          },
                                          [
                                            _c(
                                              "div",
                                              [
                                                _c("q-btn", {
                                                  staticClass: "large-cta-btn",
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "button.addLogsToVirtualFromSearch"
                                                    ),
                                                    color: "accent",
                                                    "text-color": "accentText",
                                                    size: "xl",
                                                    "no-caps": ""
                                                  },
                                                  on: {
                                                    click: _vm.addFromSearch
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              [
                                                _c("q-btn", {
                                                  staticClass: "large-cta-btn",
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "button.addLogsToVirtualFromWatchlist"
                                                    ),
                                                    color: "accent",
                                                    "text-color": "accentText",
                                                    size: "xl",
                                                    "no-caps": ""
                                                  },
                                                  on: {
                                                    click: _vm.addFromWatchlist
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    : [
                                        _c(
                                          "q-btn",
                                          {
                                            staticClass: "q-mb-md",
                                            attrs: {
                                              icon: "expand_more",
                                              flat: ""
                                            },
                                            on: { click: _vm.hide }
                                          },
                                          [
                                            _c("q-tooltip", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("button.minimize")
                                                )
                                              )
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("q-toggle", {
                                          attrs: {
                                            value: _vm.showBundleImages,
                                            label: _vm.$t(
                                              "label.showBundleImages"
                                            ),
                                            disable: _vm.updating
                                          },
                                          on: { input: _vm.toggleBundleImages }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "q-tabs",
                                          {
                                            staticClass: "text-black",
                                            attrs: {
                                              "active-color": "primary",
                                              align: "left",
                                              dense: "",
                                              "no-caps": ""
                                            },
                                            model: {
                                              value: _vm.tab,
                                              callback: function($$v) {
                                                _vm.tab = $$v
                                              },
                                              expression: "tab"
                                            }
                                          },
                                          [
                                            _c("q-tab", {
                                              attrs: {
                                                name: "bundles",
                                                label: _vm.$t(
                                                  "virtual.bundleTab"
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("q-tab", {
                                              attrs: {
                                                name: "images",
                                                label: _vm.$t(
                                                  "virtual.imageTab"
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("q-tab", {
                                              attrs: {
                                                name: "logInfo",
                                                label: _vm.$t("virtual.infoTab")
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("q-separator"),
                                        _vm._v(" "),
                                        _c(
                                          "q-tab-panels",
                                          {
                                            attrs: {
                                              animated: "",
                                              "keep-alive": ""
                                            },
                                            model: {
                                              value: _vm.tab,
                                              callback: function($$v) {
                                                _vm.tab = $$v
                                              },
                                              expression: "tab"
                                            }
                                          },
                                          [
                                            _c(
                                              "q-tab-panel",
                                              { attrs: { name: "bundles" } },
                                              [
                                                _c("q-table", {
                                                  attrs: {
                                                    columns:
                                                      _vm.logTableColumns,
                                                    data: _vm.virtualLog.logs,
                                                    "rows-per-page-options": [
                                                      5
                                                    ],
                                                    "rows-per-page-label": "",
                                                    "row-key": "logId",
                                                    flat: "",
                                                    dense: ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "body",
                                                        fn: function(props) {
                                                          return [
                                                            _c(
                                                              "q-tr",
                                                              {
                                                                staticClass:
                                                                  "log-selector-tr",
                                                                class: {
                                                                  selected:
                                                                    _vm.selectedLog ===
                                                                    props.row
                                                                },
                                                                attrs: {
                                                                  props: props
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.selectLog(
                                                                      props.row
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "q-td",
                                                                  {
                                                                    key:
                                                                      "logNo",
                                                                    attrs: {
                                                                      props: props
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        props
                                                                          .row
                                                                          .strLogNo ||
                                                                          props
                                                                            .row
                                                                            .logNo
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "q-td",
                                                                  {
                                                                    key:
                                                                      "species",
                                                                    attrs: {
                                                                      props: props
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        props
                                                                          .row
                                                                          .strSpecieName ||
                                                                          props
                                                                            .row
                                                                            .species
                                                                            .name
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "q-td",
                                                                  {
                                                                    key:
                                                                      "actions",
                                                                    attrs: {
                                                                      props: props
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "q-badge",
                                                                      {
                                                                        attrs: {
                                                                          color: _vm.logBundleCountColor(
                                                                            props.row
                                                                          ),
                                                                          "text-color":
                                                                            "black"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.addedBundles(
                                                                              props.row
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "q-btn",
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            "add",
                                                                          loading:
                                                                            _vm.loadingBundles,
                                                                          flat:
                                                                            ""
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            return _vm.addAllBundles(
                                                                              props.row
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "q-tooltip",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "virtual.addAllBundles"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "q-btn",
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            "delete",
                                                                          loading:
                                                                            _vm.removingLog,
                                                                          flat:
                                                                            ""
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            return _vm.removeLog(
                                                                              props.row
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "q-tooltip",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "virtual.removeLog"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.isSelected(
                                                              props.row
                                                            )
                                                              ? _c(
                                                                  "q-tr",
                                                                  {
                                                                    attrs: {
                                                                      props: props
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "q-td",
                                                                      {
                                                                        attrs: {
                                                                          colspan:
                                                                            "100%"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm.loadingBundles
                                                                          ? _c(
                                                                              "q-spinner-cube",
                                                                              {
                                                                                attrs: {
                                                                                  color:
                                                                                    "primary",
                                                                                  size:
                                                                                    "2em"
                                                                                }
                                                                              }
                                                                            )
                                                                          : _c(
                                                                              "q-table",
                                                                              {
                                                                                staticClass:
                                                                                  "sticky-header-table small-scrolling-table",
                                                                                attrs: {
                                                                                  columns:
                                                                                    _vm.bundleTableColumns,
                                                                                  data:
                                                                                    props
                                                                                      .row
                                                                                      .bundles,
                                                                                  pagination:
                                                                                    _vm.bundleTablePagination,
                                                                                  "row-key":
                                                                                    "intBundleId",
                                                                                  flat:
                                                                                    "",
                                                                                  "hide-bottom":
                                                                                    "",
                                                                                  dense:
                                                                                    ""
                                                                                },
                                                                                on: {
                                                                                  "update:pagination": function(
                                                                                    $event
                                                                                  ) {
                                                                                    _vm.bundleTablePagination = $event
                                                                                  },
                                                                                  "row-click":
                                                                                    _vm.bundleTableRowClick
                                                                                },
                                                                                scopedSlots: _vm._u(
                                                                                  [
                                                                                    {
                                                                                      key:
                                                                                        "body-cell-toggle",
                                                                                      fn: function(
                                                                                        cell
                                                                                      ) {
                                                                                        return [
                                                                                          _c(
                                                                                            "q-td",
                                                                                            [
                                                                                              _c(
                                                                                                "q-checkbox",
                                                                                                {
                                                                                                  attrs: {
                                                                                                    value:
                                                                                                      _vm.indexInVirtualLog(
                                                                                                        cell.row
                                                                                                      ) >
                                                                                                      -1
                                                                                                  },
                                                                                                  on: {
                                                                                                    input: function(
                                                                                                      $event
                                                                                                    ) {
                                                                                                      return _vm.toggleFromVirtualLog(
                                                                                                        cell.row,
                                                                                                        _vm.selectedLog
                                                                                                      )
                                                                                                    }
                                                                                                  }
                                                                                                }
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          )
                                                                                        ]
                                                                                      }
                                                                                    }
                                                                                  ],
                                                                                  null,
                                                                                  true
                                                                                )
                                                                              }
                                                                            )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    1128924338
                                                  )
                                                }),
                                                _vm._v(" "),
                                                _c("q-separator", {
                                                  attrs: { spaced: "" }
                                                }),
                                                _vm._v(" "),
                                                _c("q-table", {
                                                  staticClass:
                                                    "sticky-header-table small-scrolling-table",
                                                  attrs: {
                                                    columns:
                                                      _vm.virtualLogColumns,
                                                    data:
                                                      _vm.virtualLog.bundles,
                                                    pagination:
                                                      _vm.virtualLogTablePagination,
                                                    "row-key": "intBundleId",
                                                    flat: "",
                                                    "hide-bottom": "",
                                                    dense: ""
                                                  },
                                                  on: {
                                                    "update:pagination": function(
                                                      $event
                                                    ) {
                                                      _vm.virtualLogTablePagination = $event
                                                    }
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "top-left",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "q-table__title table-title"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "virtual.virtualBlock"
                                                                      )
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      },
                                                      {
                                                        key:
                                                          "body-cell-actions",
                                                        fn: function(cell) {
                                                          return [
                                                            _c(
                                                              "q-td",
                                                              [
                                                                _c("q-btn", {
                                                                  attrs: {
                                                                    icon:
                                                                      "delete",
                                                                    flat: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeBundle(
                                                                        cell.row
                                                                      )
                                                                    }
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                _c("q-btn", {
                                                                  attrs: {
                                                                    icon:
                                                                      "arrow_upward",
                                                                    flat: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.moveBundleUp(
                                                                        cell.row
                                                                      )
                                                                    }
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                _c("q-btn", {
                                                                  attrs: {
                                                                    icon:
                                                                      "arrow_downward",
                                                                    flat: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.moveBundleDown(
                                                                        cell.row
                                                                      )
                                                                    }
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    437832222
                                                  )
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "q-tab-panel",
                                              { attrs: { name: "images" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "log-selector-scroll q-mt-md"
                                                  },
                                                  _vm._l(
                                                    _vm.virtualLog.logs,
                                                    function(log) {
                                                      return _c(
                                                        "log-teaser",
                                                        {
                                                          key: log.logId,
                                                          staticClass:
                                                            "log-selector q-mr-md",
                                                          class: {
                                                            selected:
                                                              _vm.selectedLog ===
                                                              log
                                                          },
                                                          attrs: { log: log },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.selectLog(
                                                                log
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "q-btn",
                                                            {
                                                              staticClass:
                                                                "absolute-top-right q-mr-md teaser-selector",
                                                              class: _vm.teaserSelectorClass(
                                                                log
                                                              ),
                                                              attrs: {
                                                                icon: "photo",
                                                                flat: "",
                                                                dense: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.setTeaser(
                                                                    log.teaser ||
                                                                      log.strPreviewImageURL
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("q-tooltip", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "tooltip.asPreviewImage"
                                                                    )
                                                                  )
                                                                )
                                                              ])
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _vm.selectedLog
                                                  ? [
                                                      _c("q-separator", {
                                                        attrs: { spaced: "" }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("log-images-picker", {
                                                        attrs: {
                                                          props:
                                                            _vm.logImagesPickerProps,
                                                          "virtual-log":
                                                            _vm.virtualLog,
                                                          emit: "",
                                                          reverse: "",
                                                          large: "",
                                                          virtual: ""
                                                        },
                                                        on: {
                                                          "change-teaser":
                                                            _vm.setTeaser
                                                        },
                                                        model: {
                                                          value: _vm.imageUrls,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.imageUrls = $$v
                                                          },
                                                          expression:
                                                            "imageUrls"
                                                        }
                                                      })
                                                    ]
                                                  : _vm._e()
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "q-tab-panel",
                                              { attrs: { name: "logInfo" } },
                                              [
                                                _c("log-property-form", {
                                                  attrs: {
                                                    log: _vm.virtualLog
                                                  },
                                                  on: {
                                                    update:
                                                      _vm.updateLogPropsAndSave
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                ]
                          ],
                          2
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }